import { BaseFieldConfig } from "../../../CommonElements/DynamicFieldRenderer";

export type AttendanceCorrectionFieldConfig = BaseFieldConfig & {
  showCondition?: (values: any) => boolean;
};

export const attendanceCorrectionFormFields: AttendanceCorrectionFieldConfig[] =
  [
    // --- Basic info ---
    {
      name: "emp_name",
      label: "Employee Name",
      type: "text",
      col: 6,
      disabled: true,
    },
    {
      name: "date",
      label: "Date",
      type: "text",
      col: 6,
      disabled: true,
    },

    // --- Edit Time Selection (radio buttons) ---
    {
      name: "editTime",
      label: "Which time would you like to edit?",
      type: "radio",
      col: 12,
      options: [
        { value: "0", label: "In Time" },
        { value: "1", label: "Out Time" },
        { value: "2", label: "Both Times" },
      ],
    },

    // --- Conditional In/Out Time Inputs ---
    {
      name: "in_time",
      label: "Check In Time",
      type: "time",
      col: 6,
      showCondition: (values) => ["0", "2"].includes(values.editTime),
    },
    {
      name: "out_time",
      label: "Check Out Time",
      type: "time",
      col: 6,
      showCondition: (values) => ["1", "2"].includes(values.editTime),
    },

    // --- Reason Textarea ---
    {
      name: "reason",
      label: "Reason",
      type: "textarea",
      rows: 2,
      col: 12,
    },

    // --- Manager and CC Fields ---
    {
      name: "manager",
      label: "To",
      type: "text",
      col: 5,
      disabled: true,
    },
    {
      name: "cc",
      label: "CC",
      type: "text",
      col: 7,
      disabled: true,
    },
  ];
